(function () {
    "use strict";
    angular
        .module("common.services")
        .factory("connectionsResource", ["$resource", connectionsResource]);
    function connectionsResource($resource) {
        return $resource("/api/connections/:id/:action/:actionValue", {}, {
            getConnectionsListViewModel: {
                method: "GET",
                params: { action: "connectionsListViewModel" }
            },
            getBambooHRv1ImportViewModel: {
                method: "GET",
                params: { action: "bambooHRv1ImportViewModel" }
            },
            postBambooHRv1ImportTestConnection: {
                method: "POST",
                params: { action: "bambooHRv1ImportTestConnection" }
            },
            postBambooHRv1ImportRunNow: {
                method: "POST",
                params: { action: "bambooHRv1ImportRunNow" }
            },
            saveBambooHRv1Import: {
                method: "POST",
                params: { action: "bambooHRv1Import" }
            },
            postTaxJarSalesTaxV2TestConnection: {
                method: "POST",
                params: { action: "taxJarSalesTaxV2TestConnection" }
            },
            getTaxJarSalesTaxV2ViewModel: {
                method: "GET",
                params: { action: "taxJarSalesTaxV2ViewModel" }
            },
            postTaxJarSalesTaxV2: {
                method: "POST",
                params: { action: "taxJarSalesTaxV2" }
            },
            getDynamics365V82ViewModel: {
                method: "GET",
                params: { action: "dynamics365V82ViewModel" }
            },
            postDynamics365V82: {
                method: "POST",
                params: { action: "dynamics365V82" }
            },
            postDynamics365V82TestConnection: {
                method: "POST",
                params: { action: "dynamics365V82TestConnection" }
            },
            getSkillBuilderBridgeViewModel: {
                method: "GET",
                params: { action: "skillBuilderBridgeViewModel" }
            },
            postSkillBuilderBridgeImportRunNow: {
                method: "POST",
                params: { action: "skillBuilderBridgeImportRunNow" }
            },
            postSkillBuilderBridgeAccountExportRunNow: {
                method: "POST",
                params: { action: "skillBuilderBridgeAccountExportRunNow" }
            },
            postSkillBuilderBridgeCompletionExportRunNow: {
                method: "POST",
                params: { action: "skillBuilderBridgeCompletionExportRunNow" }
            },
            getDisqusViewModel: {
                method: "GET",
                params: { action: "disqusViewModel" }
            },
            postDisqus: {
                method: "POST",
                params: { action: "disqus" }
            },
            isDisqusEnabled: {
                method: "GET",
                params: { action: "disqus", actionValue: "enabled" }
            }
        });
    }
}());
